const dev = {
    endpoints: {
        itarXferAdminAuthn: "https://b7ad4sdes0.execute-api.us-west-2.amazonaws.com/prd/itarXferAdminAuthn",
        itarXferAdminAuthz: "https://b7ad4sdes0.execute-api.us-west-2.amazonaws.com/prd/itarXferAdminAuthz",
        itarXferCreateSecret: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateSecret",
        itarXferAuthzSecret: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAuthzSecret",
        itarXferSinglePartUpload: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferSinglePartUpload",
        itarXferStartMultipartUpload: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferStartMultipartUpload",
        itarXferGetUploadPartUrl: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferGetUploadPartUrl",
        itarXferCompleteMultipartUpload: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCompleteMultipartUpload",
        itarXferCreateTinyUrlCode: 'https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateTinyUrlCode',
        itarXferLookupTinyUrlCode: 'https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferLookupTinyUrlCode',
    },
    downloadBaseUrl: 'http://localhost:3000/download'
};

const prd = {
    endpoints: {
        itarXferAdminAuthn: "https://b7ad4sdes0.execute-api.us-west-2.amazonaws.com/prd/itarXferAdminAuthn",
        itarXferAdminAuthz: "https://b7ad4sdes0.execute-api.us-west-2.amazonaws.com/prd/itarXferAdminAuthz",
        itarXferCreateSecret: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateSecret",
        itarXferAuthzSecret: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAuthzSecret",
        itarXferSinglePartUpload: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferSinglePartUpload",
        itarXferStartMultipartUpload: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferStartMultipartUpload",
        itarXferGetUploadPartUrl: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferGetUploadPartUrl",
        itarXferCompleteMultipartUpload: "https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCompleteMultipartUpload",
        itarXferCreateTinyUrlCode: 'https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateTinyUrlCode',
        itarXferLookupTinyUrlCode: 'https://the0pkzgph.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferLookupTinyUrlCode',
    },
    downloadBaseUrl: 'https://itar.ascendingnode.tech/download'
};

const configMap = {
    'prd': prd,
    'dev': dev,
};

const config = configMap[process.env.REACT_APP_STAGE];

export const endpoints = config.endpoints;
export const downloadBaseUrl = config.downloadBaseUrl;
